import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useCycles({ teamId, memberId }) {
  const [cycles, setCycles] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.cycles.list(teamId), {
        params: { memberId },
      })
      .then((response) => {
        setCycles(response.data.data);
      });
  }, []);

  return cycles;
}
